import { Action } from "redux"
import { IAddin } from "./index"

export const REQUEST_ADDINS = "ADDINS_REQUEST_ADDINS"
export const RECEIVE_ADDINS = "ADDINS_RECEIVE_ADDINS"

export const requestAddins = (): Action => ({ type: REQUEST_ADDINS })

export interface ReceiveAddinsAction extends Action {
    addins: IAddin[]
}

export const receiveAddins = (addins: IAddin[]): ReceiveAddinsAction => ({
    type: RECEIVE_ADDINS,
    addins,
})

export const mapDispatchToProps = {
    requestAddins,
    receiveAddins,
}

export type DispatchProps = typeof mapDispatchToProps
